<div
  *ngrxLet="{
    isSaving: isSaving$,
    isLoading: isLoading$,
  } as vm"
  class="flex-row w-100 h-100 root-content-wrapper"
>
  <app-sidebar></app-sidebar>
  <div class="w-100 flex-col min-w-0">
    <ui-header-with-breadcrumbs
      [selectBreadcrumbs]="(breadcrumbs$ | async) || []"
    >
      <ng-container *ngIf="showOrgSettingsSave()">
        <ui-button
          *rbacOrgAllow="[permissions.OrganizationSettingsEditOrganization]"
          type="primary"
          [loading]="vm.isSaving"
          [disabled]="vm.isLoading"
          [text]="'COMMON.SAVE' | translate"
          (clickAction)="save()"
        ></ui-button>
      </ng-container>
    </ui-header-with-breadcrumbs>
    <div class="page-content flex min-h-0">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
